import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface NoDisputeButtonProps {
  onClick?: () => void;
}

const LANG_BASE = "vessel-call.operations";

const NoDisputeButton = ({ onClick }: NoDisputeButtonProps) => {
  return (
    <FlowActionButton
      langBase={LANG_BASE}
      permission={"canRequestDispute"}
      isActionAvailable={true}
      labelKey="no-dispute"
      testId="operations-non-dispute-button"
      type="button"
      variant="contained"
      startIcon={<CheckCircleOutlineIcon />}
      onClick={() => onClick?.()}
    />
  );
};

export default NoDisputeButton;
